document.addEventListener("DOMContentLoaded", () => {
  const explorers = document.querySelectorAll(".js-explorer");
  let observer = null;

  function initObserver() {
    if (observer) return;

    observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.5) {
            entry.target.classList.add("c-explorer--visible");
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    explorers.forEach((explorer) => observer.observe(explorer));
  }

  function destroyObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    explorers.forEach((explorer) =>
      explorer.classList.remove("c-explorer--visible")
    );
  }

  function checkWindowSize() {
    if (window.innerWidth > 780) {
      initObserver();
    } else {
      destroyObserver();
    }
  }

  checkWindowSize();

  window.addEventListener("resize", checkWindowSize);
});
